// API pages are zero-based; table controls are one-based.
const listKeys = ["content", "records", "items", "products", "vendors", "warehouses", "allocations", "customerAllocations", "rows", "data"];
const metaKeys = ["pageNumber", "pageSize", "number", "size", "totalElements", "total", "totalCount", "page", "totalPages", "first", "last", "empty"];
const integer = (value, fallback, minimum = 0) => value != null && value !== "" && Number.isFinite(Number(value)) && Number(value) >= minimum ? Math.trunc(Number(value)) : fallback;

export function normalizePageResponse(response, { page = 0, size = 10, paginate = true } = {}) {
  let payload = response;
  let metadata = {};
  for (let depth = 0; depth < 8 && payload && !Array.isArray(payload); depth += 1) {
    metadata = { ...metadata, ...Object.fromEntries(metaKeys.filter(key => payload[key] != null).map(key => [key, payload[key]])) };
    if (listKeys.some(key => key !== "data" && Array.isArray(payload[key]))) break;
    if (payload.data == null) break;
    payload = payload.data;
  }
  const records = Array.isArray(payload) ? payload : listKeys.map(key => payload?.[key]).find(Array.isArray) || [];
  const serverPaged = Object.keys(metadata).length > 0;
  const pageSize = integer(metadata.pageSize ?? metadata.size, integer(size, 10, 1), 1);
  const totalElements = serverPaged ? integer(metadata.totalElements ?? metadata.total ?? metadata.totalCount, records.length) : records.length;
  const totalPages = serverPaged ? integer(metadata.totalPages, Math.ceil(totalElements / pageSize)) : Math.ceil(totalElements / pageSize);
  const requestedPage = integer(page, 0);
  const pageNumber = serverPaged ? integer(metadata.pageNumber ?? metadata.number ?? metadata.page, requestedPage) : Math.min(requestedPage, Math.max(0, totalPages - 1));
  const content = serverPaged || !paginate ? records : records.slice(pageNumber * pageSize, (pageNumber + 1) * pageSize);
  return {
    ...(payload && !Array.isArray(payload) ? payload : {}),
    content, totalElements, totalPages, pageNumber, pageSize,
    number: pageNumber, size: pageSize, serverPaged,
    first: typeof metadata.first === "boolean" ? metadata.first : pageNumber === 0,
    last: typeof metadata.last === "boolean" ? metadata.last : pageNumber >= totalPages - 1,
    empty: typeof metadata.empty === "boolean" ? metadata.empty : content.length === 0,
  };
}

// Combined tables and local filters must collect all pages before filtering.
export async function collectPageRecords(fetchPage, size = 10) {
  let page = 0;
  const records = [];
  while (true) {
    const result = normalizePageResponse(await fetchPage(page, size), { page, size, paginate: false });
    records.push(...result.content);
    if (!result.serverPaged || result.last || result.empty) return records;
    const nextPage = result.pageNumber + 1;
    if (nextPage <= page) throw new Error("The server did not advance to the requested page.");
    page = nextPage;
    size = result.pageSize;
  }
}